export default {
  global: {
    body: {
      bg: 'greys.white',
      fontSize: '0.875rem',
      overflow: 'hidden',
    },
  },
}
